"use strict";
'use es6';
/**
 * Fork of UIComponents/nav/UINestedNavItem
 * https://git.hubteam.com/HubSpot/UIComponents/blob/f5f8211/UIComponents/static-2.3729/js/nav/UINestedNavItem.js
 */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _NavListItem = _interopRequireDefault(require("./NavListItem"));

var _default = (0, _createReactClass.default)({
  displayName: 'NestedNavItem',
  propTypes: (0, _extends2.default)({}, _NavListItem.default.propTypes),
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _NavListItem.default.defaultProps);
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children"]);
    return _react.default.createElement(_NavListItem.default, (0, _extends2.default)({
      iconRight: children != null ? 'down' : null
    }, rest), children);
  }
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/nav/NestedNavItem.js
// module id = 260
// module chunks = 209 210 211 212